import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Icon({
  icon,
  className,
  size,
  variant,
  type,
  bordered,
  light,
  disabled,
  withBackground,
  father,
  ...rest
}) {
  return (
    <div
      className={classNames(
        'icon-container',
        className,
        size && `icon-${size}`,
        variant && `icon-${variant}`,
        bordered && 'icon-bordered',
        light && 'icon-light',
        disabled && 'icon-disabled',
        withBackground && 'icon-with-background',
        father === 'bl' && 'icon-bl',
      )}
    >
      <i className={classNames('icon', `${father}-${icon}${type && `-${type}`}`)} {...rest} />
    </div>
  );
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
  ]),
  type: PropTypes.oneOf(['line', 'fill']),
  bordered: PropTypes.bool,
  light: PropTypes.bool,
  disabled: PropTypes.bool,
  father: PropTypes.string,
};

Icon.defaultProps = {
  className: '',
  size: null,
  variant: null,
  type: '',
  bordered: false,
  light: false,
  disabled: false,
  father: 'ri',
};

export default Icon;
